import { TrackingSys } from "./../../../../../constants/TrackingSys";
import { CodStatusTracking } from "../../../../../constants/CodStatusTracking";

export function handleInputChange(setValue, data, setData, onFormChange, label, newValue, index) {
  setValue(prevValues => ({ ...prevValues, [index]: newValue }));
  
  let value = newValue === "" ? null : newValue;

  let updatedFields = data.fields.map(field => {
    if(field.labelText === label) {
      return { ...field, inputValue: value };
    }
    
    else return field;
  });

  if (data.trackingSysId === TrackingSys.EXPORT_MILESTONES && index === CodStatusTracking.ITL) {
    updatedFields = replicateValue(updatedFields, newValue, CodStatusTracking.HTS, CodStatusTracking.ITI);
    const result = generateResult(updatedFields);
    setValue(prevValues => ({ ...prevValues, ...result }));
  }

  if (data.trackingSysId === TrackingSys.IMPORT_MILESTONES) {
    if (index === CodStatusTracking.CPC) {
      updatedFields = replicateValue(updatedFields, newValue, CodStatusTracking.DAS, CodStatusTracking.POD);
      const result = generateResult(updatedFields);
      setValue(prevValues => ({ ...prevValues, ...result }));
    }

    if (index === CodStatusTracking.HTB) {
      updatedFields = replicateValue(updatedFields, newValue, CodStatusTracking.CAC);
      const result = generateResult(updatedFields);
      setValue(prevValues => ({ ...prevValues, ...result }));
    }
  }

  const updatedData = validateFields({ ...data, fields: updatedFields });

  setData(updatedData);
  onFormChange(updatedData);
};

export function extractFormboxLabels(setFormboxLabels, data) {
  const texts = data.fields.map(field => {
    return field.inputValue;
  });

  setFormboxLabels(texts);
};

export function formatInputValue(inputValue) {
  if(inputValue) {
    var date = new Date(inputValue);
    var month = '' + (date.getMonth() + 1);
    var day = '' + date.getDate();
    var year = date.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  else return null;
};

export function validateFields(form) {
  form.fields.forEach((field, index) => {
    var isInvalid = {status: false, nextLabelText: null, previousLabelText: null};
  
    if(field.inputValue && field.inputEditable) {
      field.inputValue = field.inputValue.includes("T") ? field.inputValue : field.inputValue + "T00:00:00";
      const firstNextFilledField = form.fields.slice(index + 1).find(nextField => nextField.inputValue !== null); //primeiro campo depois dele preenchido
      const firstPreviousFilledField = form.fields.slice(0, index).reverse().find(previousField => previousField.inputValue !== null); //primeiro campo antes dele preenchido

      if(firstPreviousFilledField && !firstPreviousFilledField.inputEditable) { //campo anterior é um campo giantsys preenchido
        if(firstNextFilledField) {
          if((new Date(firstPreviousFilledField.inputValue).getTime() > new Date(field.inputValue).getTime()) || (new Date(firstNextFilledField.inputValue).getTime() < new Date(field.inputValue).getTime())) { //valor precisa estar entre o campo anterior e o próximo
            isInvalid = {status: true, nextLabelText: firstNextFilledField.labelText, previousLabelText: firstPreviousFilledField.labelText};
          }
        }

        else {
          if(new Date(firstPreviousFilledField.inputValue).getTime() > new Date(field.inputValue).getTime()) { //valor precisa ser maior que o campo anterior
            isInvalid = {status: true, previousLabelText: firstPreviousFilledField.labelText};
          }
        }
      }
      
      else if(firstNextFilledField) {
        if(new Date(firstNextFilledField.inputValue).getTime() < new Date(field.inputValue).getTime()) { //valor precisa estar menor que próximo
          isInvalid = {status: true, nextLabelText: firstNextFilledField.labelText};
        }
      }
    }

    field.isInvalid = isInvalid;
  });
  
  return form;
}

function replicateValue(updatedFields, newValue, fieldReplicateOne, fieldReplicateTwo = null) {
  return updatedFields.map(field => {
    if (fieldReplicateTwo) {
      if (field.id === fieldReplicateOne || field.id === fieldReplicateTwo) {
        return { ...field, inputValue: newValue };
      }
    } else {
      if (field.id === fieldReplicateOne) {
        return { ...field, inputValue: newValue };
      }
    }
    return field;
  });
}

function generateResult(updatedFields) {
  return updatedFields.reduce((acc, item) => {
    acc[item.id] = item.inputValue?.toString()?.split("T")[0];
    return acc;
  }, {});
}
